import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Button } from '@mui/material'

const SliderRound = ({ backgroundColor = 'primary.main', onClick = () => { } }: { backgroundColor?: string, onClick?: () => void }) => {
  return (
    <Box sx={{
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor,
      cursor: 'pointer',
    }} onClick={onClick} />
  )
}

const SliderRoundSelected = ({ onClick = () => { } }: { onClick?: () => void }) => {
  return (
    <Stack direction="row" sx={{ position: 'relative' }} mr={1.5}>
      <Box sx={{ position: 'absolute' }}><SliderRound onClick={onClick} /></Box>
      <Box sx={{ position: 'absolute', left: 2 }}><SliderRound onClick={onClick} /></Box>
      <Box sx={{ position: 'absolute', left: 4 }}><SliderRound onClick={onClick} /></Box>
      <Box sx={{ position: 'absolute', left: 6 }}><SliderRound onClick={onClick} /></Box>
    </Stack>
  )
}

export const Slider = ({ nbSteps = 1, step = 0, onSelect = () => { } }: { nbSteps: number, step: number, onSelect: (step: number) => void }) => {
  return (
    <Stack direction="row" gap={1} mt={2} alignSelf={'center'}>
      {Array.from({ length: nbSteps }).map((_, index) =>
        index === step ? (
          <SliderRoundSelected key={index} onClick={() => onSelect(index)} />
        ) : (
          <SliderRound key={index} backgroundColor={'#DBE8FE'} onClick={() => onSelect(index)} />
        )
      )}
    </Stack>
  )
}

interface ModelStepsProps {
  nbSteps: number
  disabledNext?: boolean
  children: React.ReactNode
  step: number
  loading?: boolean
  onSelect: (step: number) => void
}
const ModelSteps: React.FC<ModelStepsProps> = ({ nbSteps = 1, children, step, disabledNext = false, loading = false, onSelect }) => {
  const { t } = useTranslation();
  const hasPrevious = useMemo(() => {
    return step > 0;
  }, [step]);

  const hasNext = useMemo(() => {
    return step < nbSteps - 1;
  }, [step, nbSteps]);

  return (
    <Stack gap={2} flexGrow={1} justifyContent="space-between">
      {children}
      <Stack direction="row" gap={1} mt={2} alignSelf={'center'}>
        {
          hasPrevious && (
            <Button variant="outlined" onClick={() => onSelect(step - 1)} size="small">
              {t('ui_elements.form_previous')}
            </Button>
          )
        }
        {
          hasNext && (
            <Button variant="contained" color="primary" onClick={() => onSelect(step + 1)} size="small" disabled={disabledNext || loading}>
              {t('ui_elements.form_next')}
            </Button>
          )
        }
        {
          !hasNext && (
            <Button variant="contained" color="primary" onClick={() => onSelect(step + 1)} size="small" disabled={loading}>
              {t('ui_elements.close')}
            </Button>
          )
        }
      </Stack>
    </Stack>
  )
}



export default ModelSteps